import { Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import * as CustomerPaymentMethodsSelectors from './customer-payment-methods.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class CustomerPaymentMethodsFacade implements GbBaseFacade {
  loaded$ = this.store.pipe(select(CustomerPaymentMethodsSelectors.getCustomerPaymentMethodsLoaded))
  allCustomerPaymentMethods$ = this.store.pipe(select(CustomerPaymentMethodsSelectors.getAllCustomerPaymentMethods))
  selectedCustomerPaymentMethodUuid$ = this.store.pipe(select(CustomerPaymentMethodsSelectors.getSelectedId))
  hasCards$ = (includeDigitalWallets = false) =>
    this.store.pipe(select(CustomerPaymentMethodsSelectors.getHasCards(includeDigitalWallets)))

  constructor(private readonly store: Store) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
